var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _setup.model
          ? _c("div", { staticClass: "col-lg-12" }, [
              _setup.model.PersonEnabled && _setup.model.VotingCycleStarted
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "row", staticStyle: { height: "70px" } },
                      [
                        _c("div", { staticClass: "col-sm-9" }, [
                          _setup.progressPercent == 100 &&
                          _setup.changedQuestions.length == 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "alert alert-success",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "Congratulations survey is completed! You can just close this window.."
                                    ),
                                  ]),
                                ]
                              )
                            : _c("h2", [
                                _c("span", [
                                  _vm._v(
                                    "Survey " +
                                      _vm._s(_setup.model.VotingCycle) +
                                      " for " +
                                      _vm._s(_setup.personDisplayName)
                                  ),
                                ]),
                                _vm._v(" "),
                                _setup.progress != null
                                  ? _c("span", [
                                      _vm._v(
                                        "- " +
                                          _vm._s(_setup.progressPercent) +
                                          "% (" +
                                          _vm._s(_setup.progress) +
                                          "/" +
                                          _vm._s(_setup.allQuestions.length) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._m(0),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-sm-3",
                            staticStyle: { "text-align": "right" },
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _setup.changedQuestions.length > 0,
                                    expression: "changedQuestions.length > 0",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-warning mb-2",
                                    staticStyle: { margin: "0" },
                                    attrs: {
                                      disabled: _setup.invoking,
                                      type: "button",
                                    },
                                    on: { click: _setup.handleSave },
                                  },
                                  [_vm._v(_vm._s(_setup.saveBtnTitle))]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "strong",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _setup.tick == 0 || _setup.invoking,
                                        expression: "tick == 0 || invoking",
                                      },
                                    ],
                                  },
                                  [_vm._v("Saving...")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _setup.tick > 0 && !_setup.invoking,
                                        expression: "tick > 0 && !invoking",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "Auto-save in " +
                                        _vm._s(_setup.tick) +
                                        "s"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _setup.input.QuestionsGrouping,
                            expression: "input.QuestionsGrouping",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "inlineRadio1",
                          value: "ByPerson",
                        },
                        domProps: {
                          checked: _vm._q(
                            _setup.input.QuestionsGrouping,
                            "ByPerson"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _setup.input,
                              "QuestionsGrouping",
                              "ByPerson"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio1" },
                        },
                        [_vm._v("By Person")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _setup.input.QuestionsGrouping,
                            expression: "input.QuestionsGrouping",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "inlineRadio2",
                          value: "ByCriterion",
                        },
                        domProps: {
                          checked: _vm._q(
                            _setup.input.QuestionsGrouping,
                            "ByCriterion"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _setup.input,
                              "QuestionsGrouping",
                              "ByCriterion"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio2" },
                        },
                        [_vm._v("By Competency")]
                      ),
                    ]),
                    _vm._v(" "),
                    _setup.questionsWithCommentMissing.length
                      ? _c(
                          "div",
                          { staticClass: "form-check form-check-inline" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _setup.input.QuestionsGrouping,
                                  expression: "input.QuestionsGrouping",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                id: "inlineRadio3",
                                value: "ByMissingComments",
                              },
                              domProps: {
                                checked: _vm._q(
                                  _setup.input.QuestionsGrouping,
                                  "ByMissingComments"
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _setup.input,
                                    "QuestionsGrouping",
                                    "ByMissingComments"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "inlineRadio3" },
                              },
                              [_vm._v("Missing comments")]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("h4", [_vm._v(_vm._s(_setup.questionsTitle))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }, [
                        _setup.groupByPerson
                          ? _c(
                              "ul",
                              { staticClass: "list-group" },
                              _vm._l(_setup.peopleEmails, function (p, i) {
                                return _c(
                                  "a",
                                  {
                                    key: p,
                                    staticClass: "list-group-item",
                                    class: {
                                      active:
                                        _setup.input.SelectedPersonEmail == p,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _setup.input.SelectedPersonEmail = p
                                        _setup.scrollToTop()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_setup.peopleDisplayNames[i]) +
                                        "\n                                    (" +
                                        _vm._s(_setup.getProgressByPerson(p)) +
                                        "%)\n                                    "
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress",
                                        staticStyle: { height: "2px" },
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "progress-bar bg-secondary",
                                          style: {
                                            width:
                                              _setup.getProgressByPerson(p) +
                                              "%",
                                          },
                                          attrs: { role: "progressbar" },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _setup.groupByCriterion
                          ? _c(
                              "ul",
                              { staticClass: "list-group" },
                              _vm._l(_setup.criteriaPaths, function (c) {
                                return _c(
                                  "a",
                                  {
                                    key: c,
                                    staticClass: "list-group-item",
                                    class: {
                                      active:
                                        _setup.input.SelectedCriterionPath == c,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _setup.input.SelectedCriterionPath = c
                                        _setup.scrollToTop()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(c) +
                                        "\n                                    (" +
                                        _vm._s(
                                          _setup.getProgressByCriterion(c)
                                        ) +
                                        "%)\n                                    "
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress",
                                        staticStyle: { height: "2px" },
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "progress-bar bg-secondary",
                                          style: {
                                            width:
                                              _setup.getProgressByCriterion(c) +
                                              "%",
                                          },
                                          attrs: { role: "progressbar" },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _setup.groupByMissingComments
                          ? _c("ul", { staticClass: "list-group" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "list-group-item",
                                  class: {
                                    active:
                                      _setup.input.SelectedCriterionPath ==
                                      _vm.c,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _setup.input.SelectedCriterionPath = _vm.c
                                      _setup.scrollToTop()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Missing comments\n                                    (" +
                                      _vm._s(
                                        _setup.getProgressByMissingComments()
                                      ) +
                                      "%)\n                                    "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      staticStyle: { height: "2px" },
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "progress-bar bg-secondary",
                                        style: {
                                          width:
                                            _setup.getProgressByMissingComments() +
                                            "%",
                                        },
                                        attrs: { role: "progressbar" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-9",
                          staticStyle: {
                            height: "calc(100vh - 240px)",
                            "overflow-x": "hidden",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _c("div", { ref: "questionsContainerTop" }),
                          _vm._v(" "),
                          _vm._l(_setup.questions, function (q, i) {
                            return _c(
                              "div",
                              {
                                class: {
                                  "question-bg1": i % 2 == 1,
                                  "question-bg2": i % 2 == 0,
                                },
                                staticStyle: {
                                  margin: "0 0 30px 0",
                                  padding: "10px",
                                },
                              },
                              [
                                _setup.groupByPerson
                                  ? _c("h4", [
                                      _vm._v(
                                        _vm._s(i + 1) +
                                          ". " +
                                          _vm._s(q.CriterionPath)
                                      ),
                                    ])
                                  : _setup.groupByCriterion
                                  ? _c("h4", [
                                      _vm._v(
                                        _vm._s(i + 1) +
                                          ". " +
                                          _vm._s(q.PersonDisplayName) +
                                          " (" +
                                          _vm._s(q.PersonCriteriaName) +
                                          ")"
                                      ),
                                    ])
                                  : _setup.groupByMissingComments
                                  ? _c("h4", [
                                      _vm._v(
                                        _vm._s(i + 1) +
                                          ". " +
                                          _vm._s(q.PersonDisplayName) +
                                          " (" +
                                          _vm._s(q.PersonCriteriaName) +
                                          ") in the context of " +
                                          _vm._s(q.CriterionPath)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(q.CriterionDescription)),
                                ]),
                                _vm._v(" "),
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      q.CriterionDescriptionHtml
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(q.Scale, function (lvl) {
                                  return _c(
                                    "div",
                                    {
                                      key: lvl.Value,
                                      staticClass: "form-check form-check",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: q.InputValue,
                                            expression: "q.InputValue",
                                          },
                                        ],
                                        staticClass: "form-check-input",
                                        attrs: {
                                          id: `${q.CriterionPath}_${q.PersonId}_${lvl.Value}`,
                                          name: `${q.CriterionPath}_${q.PersonId}_${lvl.Value}`,
                                          type: "radio",
                                        },
                                        domProps: {
                                          value: lvl.Value,
                                          checked: _vm._q(
                                            q.InputValue,
                                            lvl.Value
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              q,
                                              "InputValue",
                                              lvl.Value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-check-label",
                                          attrs: {
                                            for: `${q.CriterionPath}_${q.PersonId}_${lvl.Value}`,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(lvl.Label)),
                                          ]),
                                          _vm._v(" "),
                                          lvl.Value == q.InputValue &&
                                          _setup.isCommentRequired(q)
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [
                                                  _vm._v(
                                                    "(comment is required!)"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: q.InputComment,
                                      expression: "q.InputComment",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "2" },
                                  domProps: { value: q.InputComment },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          q,
                                          "InputComment",
                                          $event.target.value
                                        )
                                      },
                                      _setup.resetTicker,
                                    ],
                                  },
                                }),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ])
                : _setup.model.PersonEnabled && !_setup.model.VotingCycleStarted
                ? _c("div", { staticStyle: { margin: "30px" } }, [
                    _c("h1", [_vm._v("Voting is stopped")]),
                  ])
                : !_setup.model.PersonEnabled
                ? _c("div", { staticStyle: { margin: "30px" } }, [
                    _c("h1", [_vm._v("Not found")]),
                  ])
                : _vm._e(),
            ])
          : _c("div", { staticClass: "col-lg-12" }, [_vm._m(1)]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-light",
        attrs: {
          href: "https://301083.fs1.hubspotusercontent-na1.net/hubfs/301083/MMB%20Training/MMB%20Board%20Member%20Training.pdf",
          target: "_blank",
        },
      },
      [_c("span", { staticClass: "fa fa-info" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { margin: "30px" } }, [
      _c("h1", [_vm._v("Loading...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }